module.exports = __webpack_public_path__ + "img/FriaxLogo.9f2fb465.svg";